import { useTheme } from "@mui/material";
import { useRef } from "react";
import { useParams } from "react-router-dom";
import { DashboardDetailHeader } from "web_myplann/Dashboard/Components/DashboardDetailHeader";
import { DashboardDetailStickyHeader } from "web_myplann/Dashboard/Components/DashboardDetailStickyHeader";
import { DashboardDetailV2Content } from "web_myplann/Dashboard/Components/DashboardDetailV2Content";
import { DashboardTotalContent } from "web_myplann/Dashboard/Components/DashboardTotalContent";
import { useDashboardData } from "web_myplann/Dashboard/Hooks/useDashboardData";
import { PortfolioReportingOverviewTypeEnum } from "web_myplann/Infrastructure/Api/Api";
import { MyPlannLayout } from "web_myplann/Shared/Header/MyPlannLayout";

export const DashboardDetailV2Page = () => {
	const { type } = useParams<{ type: string }>();
	const { palette } = useTheme();
	const heroRef = useRef<HTMLDivElement>(null);

	const { dashboards } = useDashboardData();

	const dashboard =
		dashboards.find((item) => item.overviewType === type) ?? dashboards[0];

	if (!dashboard) {
		return null;
	}

	const isTotal =
		dashboard.overviewType === PortfolioReportingOverviewTypeEnum.Total;

	return (
		<MyPlannLayout
			disableContentPadding
			bgColor={palette.surface.muted}
			mainSx={{ display: "flex", flexDirection: "column" }}
		>
			<DashboardDetailStickyHeader heroRef={heroRef} dashboard={dashboard} />
			<DashboardDetailHeader heroRef={heroRef} dashboard={dashboard} />
			{isTotal ? (
				<DashboardTotalContent dashboards={dashboards} />
			) : (
				<DashboardDetailV2Content dashboard={dashboard} />
			)}
		</MyPlannLayout>
	);
};
